import { Add, ArrowDownward, ChevronLeftSharp, ChevronRightSharp, ContentCopy, Refresh, Shield, VisibilityOutlined } from '@mui/icons-material';
import { ReactComponent as DefaultPropertyImageSvg } from 'assets/svg/Default-Property-Image.svg';
import { ReactComponent as FeatureBathroomSvg } from 'assets/svg/feature-bathroom.svg';
import { ReactComponent as FeatureBedroomSvg } from 'assets/svg/feature-bedroom.svg';
import { ReactComponent as FeatureBuildAreaSvg } from 'assets/svg/feature-buildarea.svg';
import { ReactComponent as FeaturePlotSizeSvg } from 'assets/svg/feature-plotsize.svg';
import { ReactComponent as PropertiesImages } from 'assets/svg/properties-images.svg';
import { useModals } from 'pages/MainProvider';
import { useSearchAiPluginStore } from 'store/searchAiPluginStore';
import { formatNumber } from 'util/Funcs';
import SearchSection from './SearchSection';

const PreviewTesting = () => {
    const { customization, properties } = useSearchAiPluginStore();
    const { showPropertyDetailModal } = useModals();

    return (
        <div className="bg-white rounded-lg shadow-sm min-h-screen my-8">
            <div className="flex items-center justify-between px-4 py-2 border-b rounded-t-lg">
                {/* Window Controls */}
                <div className="flex items-center">
                    <div className="flex gap-2">
                        <div className="w-3.5 h-3.5 rounded-full bg-red-500"></div>
                        <div className="w-3.5 h-3.5 rounded-full bg-yellow-500"></div>
                        <div className="w-3.5 h-3.5 rounded-full bg-green-500"></div>
                    </div>
                    {/* Navigation Buttons */}
                    <div className="flex gap-2 ml-4">
                        <ChevronLeftSharp className="text-gray-600 h-5 w-5   text-sm cursor-pointer" />
                        <ChevronRightSharp className="text-gray-400 h-5 w-5 text-sm cursor-pointer" />
                    </div>
                </div>
                {/* URL/Search Bar */}
                <div className="mx-4">
                    <div className="flex items-center gap-2">
                        <Shield className="text-gray-400 text-sm" />
                        <div className="grid grid-cols-3 items-center px-3 py-1 w-[600px] bg-gray-50 rounded border">
                            <div className="col-start-2 justify-self-center">
                                <span className="text-gray-600 text-sm">samplewebsitetest.com</span>
                            </div>
                            <div className="justify-self-end">
                                <Refresh className="text-gray-600 text-sm cursor-pointer" />
                            </div>
                        </div>
                    </div>
                </div>
                {/* Additional Icons */}
                <div className="flex items-center gap-4">
                    <ArrowDownward className="text-gray-400 h-5 w-5 text-sm cursor-pointer" />
                    <Add className="text-gray-400 h-5 w-5 text-sm cursor-pointer" />
                    <ContentCopy className="text-gray-400 h-5 w-5 text-sm cursor-pointer" />
                </div>
            </div>

            {/* Main Content Area */}
            <div className="flex items-center my-3 justify-center ">
                <div className="flex items-center gap-2 text-[#3176BC] bg-gray-50 px-4 py-3 rounded-md">
                    <VisibilityOutlined className="w-5 h-5 text-gray-400" />
                    <span className="text-sm">See how your clients will interact with the search plugin</span>
                </div>
            </div>
            {/* want to end a divider line here */}
            <div className="border-b"></div>
            <div className=" h-[184px] bg-[#4EBBB8]/5 rounded-md"></div>
            {/*  */}
            <div className="flex flex-col justify-center items-center">
                <div className="text-center px-4 mt-8 ">
                    <h2 className="sm:text-xl md:text-2xl md:leading-[48px] font-bold py-2 ">
                        Let's find your perfect property match! ✨ Tell us your preferences
                        <br />
                        and We'll create a selection of the best options just for you. 🏠
                    </h2>
                    <SearchSection showImage={false} />
                </div>
                <div className="mt-10 mb-20">
                    <PropertiesImages />
                    {properties.length > 0 && (
                        <div
                            className="w-[1000px] px-4 pb-16 h-[640px] overflow-y-auto border rounded-lg shadow-sm z-10 relative sm:-mt-36 md:-mt-[375px] bg-white
                    "
                            style={{
                                scrollbarColor: `${customization.searchButtonColor} transparent`,
                                scrollbarWidth: 'thin',
                            }}
                        >
                            <div className="flex items-center mt-4 sticky top-0 bg-white z-10">
                                <h2 className="text-xl font-semibold">Property</h2>
                                <span
                                    className="ml-2 text-gray-500 shadow-sm rounded-full bg-gray-100 px-2 py-1 text-sm
                                "
                                >
                                    {properties.length}
                                </span>
                            </div>
                            {properties.map((property, index) => (
                                <div
                                    key={property.propertyId}
                                    className="border-b p-4 flex  gap-4 hover:bg-gray-50 cursor-pointer"
                                    onClick={() => showPropertyDetailModal(property, false)}
                                >
                                    <div className="w-[72px] h-[72px]">
                                        <DefaultPropertyImageSvg className={`w-full h-full`} />
                                    </div>
                                    <div className="flex-1">
                                        <div className="flex items-center gap-1">
                                            <span style={{ color: customization.searchButtonColor }}>{property?.details?.listingType}</span>
                                            <span>•</span>
                                            <span className="text-gray-600">{property.address.City}</span>
                                        </div>
                                        <h3 className="text-sm font-semibold mt-0.5">{property.title}</h3>
                                        <div className="flex flex-wrap gap-4 mt-2  text-gray-600 text-xs">
                                            <div className="flex items-center gap-1">
                                                <FeatureBedroomSvg />
                                                <span>{property.details?.bedrooms ?? 0} Bed</span>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <FeatureBathroomSvg />
                                                <span>{property.details?.bathrooms ?? 0} Bath</span>
                                            </div>
                                            <div className="flex items-center gap-1 ">
                                                <FeatureBuildAreaSvg />
                                                <span>{property.details?.sizeLiving ?? 0} m²</span>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <FeaturePlotSizeSvg />
                                                <span>{property.details?.sizePlot ?? 0} m²</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-lg font-semibold " style={{ color: customization.searchButtonColor }}>
                                        {formatNumber(property.details?.price ?? 0)} €
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PreviewTesting;
